import React from "react";
import Error from "../../assets/img/error.jpg";
// import { Link } from 'react-router-dom';
import {
  Button
} from "react-bootstrap";
// import { history } from 'helper/history';
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      message: ""
    };
    this.jumpToDashboard = this.jumpToDashboard.bind(this);
  }
  
  jumpToDashboard(){
    console.log(this.state.error);
    this.setState({error:false, message:""}, function(){
      window.location.assign("/Admin/Dashboard");
      //history.push('/Admin/dashboard');
    });
  }
  componentDidCatch(err, errInfo) {
    console.log('error', err);
    console.log('error information', errInfo);
    this.setState({
      error: true,
      message: errInfo.componentStack.toString()
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="content">
          <div>
      			<img
      				src={Error}
      				style={{  height: '100%', width: '100%' }}
              alt="error handler"
      			/>
          </div>
          <div className="text-center">
    			<span style={{ textAlign: "center", fontSize: 16, padding: 10 }}>
    				Something Went Wrong. Try Again Later
    			</span>
           <Button type='button' className="outOfTableButton customButton btn btn-info" onClick={this.jumpToDashboard} >Dashboard</Button>
          </div>
	        {
	        	/*
		        <details style={{ textAlign: "center", fontSize: 8, padding: 10 }}>
		            {this.state.message}
		        </details>
        		*/
        	}
        </div>
      );
    } else{
    	return this.props.children;
    }
  }
}

// const styles = {
//   errorContainer: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center"
//   }
// };


// WEBPACK FOOTER //
// ./src/layouts/Dashboard/ErrorBoundary.jsx